import React from 'react';
import { cn } from "@/shared/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      data-testid="skeleton"
      {...props}
    />
  )
}

export { Skeleton }
